export const URL_QUERY = {
  ACCESS_TOKEN: 'accessToken',
  REFRESH_TOKEN: 'refreshToken',
  HANDOFF: 'handoff',
}
